import de from "@/locales/de.json";

const DICTS = { de };
export const LANGS = [["it", "IT"], ["de", "DE"]];
const KEY = "synvora_lang";

const detect = () => {
  const saved = localStorage.getItem(KEY);
  if (saved === "it" || saved === "de") return saved;
  return (navigator.language || "it").toLowerCase().startsWith("de") ? "de" : "it";
};

let uiLang = detect();
let override = null;
document.documentElement.lang = uiLang;

export const getLang = () => override || uiLang;
export const getUiLang = () => uiLang;

export const tr = (s, args) => {
  const l = override || uiLang;
  let out = (l !== "it" && DICTS[l]?.[s]) || s;
  if (args) out = out.replace(/\{(\d+)\}/g, (m, i) => (args[i] ?? ""));
  return out;
};

export const withLang = (lang, fn) => {
  const prev = override;
  override = lang;
  try { return fn(); } finally { override = prev; }
};

export const withLangAsync = async (lang, fn) => {
  const prev = override;
  override = lang;
  try { return await fn(); } finally { override = prev; }
};

export const locale = () => (getLang() === "de" ? "de-CH" : "it-IT");

export const setUiLang = (lang, explicit = false) => {
  if (explicit) localStorage.setItem(`${KEY}_explicit`, "1");
  if (lang === uiLang) return;
  localStorage.setItem(KEY, lang);
  setTimeout(() => window.location.reload(), 900);
};

// profilo utente <-> lingua del browser: una scelta esplicita fatta qui vince e viene salvata nel profilo
export const reconcileLang = async (profileLang, saveProfile) => {
  if (localStorage.getItem(`${KEY}_explicit`)) {
    localStorage.removeItem(`${KEY}_explicit`);
    if (profileLang !== uiLang) await saveProfile(uiLang).catch(() => {});
  } else if ((profileLang === "it" || profileLang === "de") && profileLang !== uiLang) setUiLang(profileLang);
};
